import moment from 'moment';

import { formatDate } from '../../../helpers/formatDate';

export const GALLERY_PERIOD = {
  sevenDays: '7days',
  thirtyDays: '30days',
  singleDay: 'singleDay',
};

export const GALLERY_DEFAULT_PERIOD = GALLERY_PERIOD.sevenDays;

export const GALLERY_PERIOD_OPTIONS = [
  { value: GALLERY_PERIOD.sevenDays, label: '7 Days' },
  { value: GALLERY_PERIOD.thirtyDays, label: '30 Days' },
  { value: GALLERY_PERIOD.singleDay, label: 'Single Day' },
];

export const GALLERY_DEFAULT_SORT_FIELD = 'parent';
export const GALLERY_DEFAULT_SORT_ORDER = 1;

export const GALLERY_API_PATH = 'facility/photo-gallery';

export const GALLERY_MAX_DOWNLOAD_SELECTION = 10;
export const GALLERY_DOWNLOAD_ZIP_NAME = 'pet-photo-gallery.zip';

const GALLERY_SAMPLE_PHOTO_FILES = [
  'gallery-sample-01.jpeg',
  'gallery-sample-14.jpg',
  'gallery-sample-03.JPG',
  'gallery-sample-04.jpg',
  'gallery-sample-05.jpeg',
  'gallery-sample-06.jpeg',
  'gallery-sample-11.jpeg',
  'gallery-sample-12.jpeg',
  'gallery-sample-09.jpeg',
];

export const GALLERY_SAMPLE_PHOTO_COUNT = GALLERY_SAMPLE_PHOTO_FILES.length;

export const GALLERY_SAMPLE_PHOTOS = GALLERY_SAMPLE_PHOTO_FILES.map(
  (filename) =>
    `${process.env.PUBLIC_URL}/img/sample web gallery photos/${filename}`,
);

export function getDefaultSingleDayDate(utcOffset = 0) {
  return formatDate(
    moment()
      .utc()
      .add(Number(utcOffset) || 0, 'minutes')
      .startOf('date'),
  );
}

export function formatGallerySingleDayLabel(dateString) {
  if (!dateString || !moment(dateString).isValid()) {
    return '';
  }

  return moment(dateString).format('dddd, MMMM D, YYYY');
}

export function buildPhotoGalleryQueryParams({
  period = GALLERY_DEFAULT_PERIOD,
  singleDayDate = '',
  utcOffset = 0,
} = {}) {
  const params = {
    period,
  };

  if (period === GALLERY_PERIOD.singleDay) {
    params.singleDayDate =
      singleDayDate || getDefaultSingleDayDate(utcOffset);
  }

  return params;
}
